<template lang="pug">
.case-container
  .case-content
    .case-case__title
        .divider
        .title__content
          span {{ $t('案例分享：某奢侈品集团') }}
          span {{ $t('国际上有名的奢侈品集团。') }}
    .case-case__summary
      div
        i.iconfont.iconhangye
        span {{ $t('广告主行业：奢侈品') }}

      div
        i.iconfont.iconbumen
        span {{ $t('涉及部门：市场部') }}
    .case-case__content__item
        .content__title {{ $t('案例简介：') }}
        .content {{ $t('媒体采购时，缺少相关行业BenchMark，无法衡量资源是否买贵。') }}

    .case-case__content__item
        .content__title {{ $t('客户当前痛点：') }}
        .content {{ $t('客户在新的一年中针对媒体采购这块的预算非常大，找到现有供应商及新供应商进行比稿，但是不同媒体各方报价有明显差异，并且之前存在过执行价和比稿价有区别的情况，由于缺少相关行业BenchMark数据，难以判断报价是否合理，是否会买贵。') }}
    .case-case__content__item
        .content__title {{ $t('复歌解决方案：') }}
        .content 1）{{ $t('通过复歌的iMedia Matrix媒介数据库，基于真实的海量媒介点位及价格数据，复歌为客户所有计划采买媒体提供了这些媒体的最新刊例价、历史上同行业&同类型&同档位预算客户落地执行价、媒体核心供应商返点政策等详细信息，帮助客户更好的判断，从而辅助做决策。') }}
        .content 2）{{ $t('通过“贵了么”小程序，复歌根据不同渠道媒体为客户推荐对应核心供应商，不同于审计公司的冰冷数据和理论方法，除了给到是否买贵、哪些是行业靠前的供应商之类的信息外，复歌希望为客户提供更多可靠的供应商进行选择，真实的帮到客户。') }}
    .case-case__content__item
        .content__title {{ $t('最终结果：') }}
        .content {{ $t('客户获取的详细数据帮助其在多轮比稿中更加有效的评估供应商报价是否合理，并且部分媒体尝试使用复歌推荐的核心供应商进行投放，价格和效果双双得到保证。') }}
  MobileContact
</template>"
<script>
import MobileContact from '@/components/MobileContact'
export default {
  components: {
    MobileContact
  }
}
</script>
